// Charger Firmware translations for React Admin resource
export const chargerFirmwareResource = {
  name: 'Charger Firmware |||| Charger Firmware',
  fields: {
    id: 'ID',
    version: 'Version',
    description: 'Description',
    vendor: 'Vendor',
    model: 'Model',
    file: 'Firmware file',
    file_name: 'File Name',
    file_size: 'File Size',
    file_url: 'File URL',
    charger_models: 'Compatible Models',
    is_active: 'Active',
    release_notes: 'Release Notes',
    created_at: 'Uploaded At',
    uploaded_at: 'Uploaded At',
    updated_at: 'Updated At',
  },
};

// Custom firmware translations for components
export const chargerFirmware = {
  subtitle: 'Manage firmware files for chargers',
  validation: {
    version_required: 'Version is required',
    file_required: 'Firmware file is required',
    file_url_required: 'A valid http(s) URL is required',
    invalid_file_type: 'Invalid file type. Only .bin, .hex, .fw, .rbl files are allowed',
  },
  helpers: {
    version: 'Enter firmware version (e.g., 1.2.3)',
    description: 'Describe this firmware version and what it fixes or improves',
    vendor: 'Select charger vendor (populated from connected chargers)',
    model: 'Select charger model for this vendor',
    select_vendor_first: 'Please select a vendor first',
    charger_models: 'Select compatible charger models for this firmware',
    file_upload: 'Upload firmware binary file',
    file_url: 'Full URL where the charger can download the firmware (e.g., http://example.com/firmware.bin)',
    url_warning: 'Use this option only when the charger cannot download from https. The URL is sent to the charger as-is — make sure the file stays available at this address.',
  },
  sections: {
    basic_info: 'Firmware Information',
    file_upload: 'Firmware File',
    firmware_source: 'Firmware Source',
    compatibility: 'Compatibility',
  },
  source: {
    upload: 'Upload File',
    url: 'External URL',
  },
  actions: {
    upload: 'Upload Firmware',
    download: 'Download',
  },
  create: {
    title: 'Upload New Firmware',
    subtitle: 'Upload a new firmware file for chargers',
  },
  edit: {
    title: 'Edit Firmware Details',
    subtitle: 'Modify firmware metadata',
    fileUploadWarning: 'To upload a new firmware file, please create a new firmware entry.',
  },
  list: {
    title: 'Firmware Files',
    filters: {
      search: 'Search by version or description',
    },
    empty: {
      title: 'No firmware files found',
      subtitle: 'Upload your first firmware file to begin managing charger updates.',
    },
  },
  notifications: {
    uploaded: 'Firmware saved successfully',
    uploading: 'Uploading firmware file...',
    saving: 'Saving firmware…',
    updated: 'Firmware updated successfully',
    deleted: 'Firmware deleted successfully',
    error: {
      upload: 'Failed to upload firmware',
      update: 'Failed to update firmware',
      delete: 'Failed to delete firmware',
      file_too_large: 'File size exceeds maximum allowed size',
      load_vendors_models: 'Failed to load charger vendors and models',
      duplicate_version: 'Firmware version already exists for this vendor and model',
    },
  },
};
